/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";

import QRCode from 'qrcode';

import { obtenerActivosCodigo } from "../../../../API/Global/ActivosFijos/ActivosFijosRequest";

const EtiquetaProductoQR = () => {
  const { CodigoActivo } = useParams();

  const { Idioma } = useParams();
  const [activos, setActivos] = useState([]);

  // OBTENER LA INFORMACION
  const obtenerInformacion = async (CodigoP) => {
    const codigos = CodigoP.split(',');
    const promesasActivos = codigos.map(codigo => obtenerActivosCodigo(codigo));
    const activosTempo = await Promise.all(promesasActivos);
    const activos1 = activosTempo.flat();
    setActivos(activos1);

    generarPDF(activos1);
  };


  useEffect(() => {
    if (CodigoActivo) {
      obtenerInformacion(CodigoActivo);
    }
  }, [CodigoActivo, Idioma]);

  const generarPDF = ( activosTempo ) => {

    const contenido = [];

    activosTempo.forEach((activo, index) => {
      let CodigoQR =
      console.log(QRCode);
      QRCode.toDataURL(`${activo?.CodigoActivo}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
        console.log(url, err);
        CodigoQR = url;
      })

      contenido.push({
        table: {
          widths: ["*"],
          body: [
            [
              {
                image: CodigoQR,
                width: 212,
                height: 212,
                border: [true, true, true, false],
                margin: [-18, -2, -20, -20],
              },
            ],
            [
              { text: `${activo?.CodigoActivo}`, style: "titulo1", border: [true, false, true, false] },
            ],
            [
              { text: `${activo?.NombreActivo}`, style: "titulo2", border: [true, false, true, true] },
            ]
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return 2; 
          },
          vLineWidth: function (i, node) {
            return 2;  
          },
          hLineColor: function (i, node) {
            return 'black'; 
          },
          vLineColor: function (i, node) {
            return 'black';
          },
        },
      },
      index < activosTempo.length - 1 ? { text: '', pageBreak: 'after' } : null
      );
      
    })

    const docDefinition = {
      pageSize: {
        width: 216,
        height: 324, 
      },

      pageMargins: [15, 15, 15, 10],
      content: contenido,
      styles: {
        titulo1: {
          fontSize: 30,
          bold: true,
          alignment: "center",
        },
        titulo2: {
          fontSize: 15,
          bold: true,
          alignment: "center",
        },
      },
    };

    pdfMake.createPdf(docDefinition).open({}, window);
  };
};

export default EtiquetaProductoQR;
